import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import HistoryIcon from '@material-ui/icons/History';
import useRedirect from '@sprinx/react-routes/useRedirect';
import PageBreadcrumbsItem from '../PageBreadcrumbsItem';
import usePageHistory from '../usePageHistory';

function PageBreadcrumbsItemHistory() {
  var _usePageHistory = usePageHistory(),
      _usePageHistory2 = _slicedToArray(_usePageHistory, 2),
      getHistory = _usePageHistory2[1];

  var setRedirect = useRedirect();
  var history = getHistory().slice(1);
  return React.createElement(PageBreadcrumbsItem, {
    label: React.createElement(HistoryIcon, {
      fontSize: "small",
      color: history.length ? 'primary' : 'disabled'
    })
  }, history.length ? history.map(function (item, index) {
    return React.createElement(MenuItem, {
      key: index.toString(),
      onClick: function onClick() {
        return setRedirect(item.location);
      }
    }, item.title);
  }) : null);
}

export default PageBreadcrumbsItemHistory;